const forms = {
  state: {
    asset: null,
    assetDID: null,
    assetRegister: null,
    assetRegisterTree: null,
    assetRegisterCounter: null,
    assetRegisterTreeCounter: null,
    assetList: null,
    assetListCounter: null
  },
  mutations: {
    changeAssetRegister(state, payload) {
      state.assetRegister = payload;
    },
    changeAssetRegisterTree(state, payload) {
      state.assetRegisterTree = payload;
    },
    changeAssetList(state, payload) {
      state.assetList = payload;
    },
    changeAssetRegisterCounter(state, payload) {
      state.assetRegisterCounter = payload;
    },
    changeAssetListCounter(state, payload) {
      state.assetListCounter = payload;
    },
    changeAssetRegisterTreeCounter(state, payload) {
      state.assetRegisterTreeCounter = payload;
    },
    changeAsset(state, payload) {
      state.asset = payload;
    },
    changeAssetDID(state, payload) {
      state.assetDID = payload;
    }
  },
  actions: {
    changeAssetRegister({ commit }, payload) {
      commit("changeAssetRegister", payload);
    },
    changeAssetRegisterTree({ commit }, payload) {
      commit("changeAssetRegisterTree", payload);
    },
    changeAssetList({ commit }, payload) {
      commit("changeAssetList", payload);
    },
    changeAssetRegisterCounter({ commit }, payload) {
      commit("changeAssetRegisterCounter", payload);
    },
    changeAssetRegisterTreeCounter({ commit }, payload) {
      commit("changeAssetRegisterTreeCounter", payload);
    },
    changeAssetListCounterCounter({ commit }, payload) {
      commit("changeAssetListCounter", payload);
    },
    changeAsset({ commit }, payload) {
      // commit to store
      commit("changeAsset", payload);
    },
    changeAssetDID({ commit }, payload) {
      // commit to store
      commit("changeAssetDID", payload);
    }
  },
  getters: {
    getAssetRegister: state => {
      return state.assetRegister;
    },
    getAssetRegisterTree: state => {
      return state.assetRegisterTree;
    },
    getAssetList: state => {
      return state.assetList;
    },
    getAssetRegisterCounter: state => {
      return state.assetRegisterCounter;
    },
    getAssetRegisterTreeCounter: state => {
      return state.assetRegisterTreeCounter;
    },
    getAssetListCounter: state => {
      return state.assetListCounter;
    },
    getAsset: state => {
      return state.asset;
    },
    getAssetDID: state => {
      return state.assetDID;
    }
  }
};
// eslint-disable-next-line
export default forms;
